export type FreightType = 'percent' | 'fixed_addon' | '';
export const freightType = ['percent', 'fixed_addon'] as const;
